import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import PaymentLinkError from '../../components/PaymentLinkError';

const UsedUniqueLink = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('components->>PaymentLinkError.Payment has already been made.')} />

      <ContentTemplate>
        <PaymentLinkError
          typographyMessage={t(
            'components->>PaymentLinkError.Sorry, you have already made payment.'
          )}
          buttonMessage={t('components->>PaymentLinkError.Back to Home')}
        />
      </ContentTemplate>
    </>
  );
};

export default UsedUniqueLink;
